import React, { Component } from "react";
import Swal from "sweetalert2";
import BetterCircularProgress from "../../../components/BetterCircularProgress";
import { getDashboard } from "../../../crud/dashboard.crud";
import { formatBRL } from "../../../utils/Utils";
import { Portlet, PortletBody } from "../../../partials/content/Portlet";
import { theme } from "../../../theme/colors";
import GraficoViagensMes from "./GraficoViagensMes";

export default class DashboardPage extends Component {
    constructor() {
        super();

        this.state = {
            loading: false,
            data: null,
        };
    }

    componentDidMount = () => {
        this.setState({ loading: true });

        getDashboard()
            .then((resposta) => {
                if (resposta.data.errors) {
                    return Swal.fire("Ops!", resposta.data.errors[0], "error");
                }
                this.setState({ data: resposta.data, loading: false });
            })
            .catch(() => {
                Swal.fire("Ops!", "Parece que houve um problema. Por favor, entre em contato com o suporte.", "error");
                this.setState({ loading: false });
            });
    };

    render() {

        return (
            <BetterCircularProgress loading={this.state.loading}>
                <div className="row">
                    <div className="col-md-12 col-lg">
                        <Portlet className="kt-portlet--border-bottom-brand" style={{ borderBottom: `4px solid ${theme.secondaryColors[6]}` }} fluidHeight={true}>
                            <PortletBody>
                                <div className="kt-widget26">
                                    <div className="kt-widget26__content">
                                        <span className="kt-widget26__desc color-gray-600">Faturamento mensal</span>

                                        <span className="kt-widget26__number color-gray-900">
                                            {this.state.data?.faturamento_mensal != null ? formatBRL(this.state.data.faturamento_mensal) : "R$ 0,00"}
                                        </span>
                                    </div>
                                </div>
                            </PortletBody>
                        </Portlet>
                    </div>

                    <div className="col-md-12 col-lg">
                        <Portlet className="kt-portlet--border-bottom-brand" style={{ borderBottom: `4px solid ${theme.secondaryColors[6]}` }} fluidHeight={true}>
                            <PortletBody>
                                <div className="kt-widget26">
                                    <div className="kt-widget26__content">
                                        <span className="kt-widget26__desc color-gray-600">Motoristas cadastrados</span>

                                        <span className="kt-widget26__number color-gray-900">
                                            {this.state.data?.motoristas_cadastrados ?? '0'}
                                        </span>
                                    </div>
                                </div>
                            </PortletBody>
                        </Portlet>
                    </div>

                    <div className="col-md-12 col-lg">
                        <Portlet className="kt-portlet--border-bottom-brand" style={{ borderBottom: `4px solid ${theme.secondaryColors[6]}` }} fluidHeight={true}>
                            <PortletBody>
                                <div className="kt-widget26">
                                    <div className="kt-widget26__content">
                                        <span className="kt-widget26__desc color-gray-600">Clientes cadastrados</span>

                                        <span className="kt-widget26__number color-gray-900">
                                            {this.state.data?.clientes_cadastrados ?? '0'}
                                        </span>
                                    </div>
                                </div>
                            </PortletBody>
                        </Portlet>
                    </div>

                    <div className="col-md-12 col-lg">
                        <Portlet className="kt-portlet--border-bottom-brand" style={{ borderBottom: `4px solid ${theme.secondaryColors[6]}` }} fluidHeight={true}>
                            <PortletBody>
                                <div className="kt-widget26">
                                    <div className="kt-widget26__content">
                                        <span className="kt-widget26__desc color-gray-600">Viagens realizadas este mês</span>

                                        <span className="kt-widget26__number color-gray-900">
                                            {this.state.data?.viagens_realizadas ?? '0'}
                                        </span>
                                    </div>
                                </div>
                            </PortletBody>
                        </Portlet>
                    </div>
                </div>
                
                <div className="row">
                    <div className="col-12">
                        <GraficoViagensMes data={this.state.data?.viagens_por_mes} />
                    </div>
                </div>
            </BetterCircularProgress>
        );
    }
}
